import { createStylesParam, StyleParamType, wixColorParam, wixFontParam } from '@wix/tpa-settings';
import {
  MY_POSTS_PAGE_TITLE_FONT,
  MY_POSTS_PAGE_TITLE_COLOR,
  MY_POSTS_PAGE_TAB_FONT,
  MY_POSTS_PAGE_TAB_COLOR,
  MY_POSTS_PAGE_ACTIVE_TAB_COLOR,
  MY_POSTS_PAGE_LINK_FONT,
  MY_POSTS_PAGE_LINK_COLOR,
  MY_POSTS_PAGE_BACKGROUND_COLOR,
  MY_POSTS_PAGE_BORDER_COLOR,
  MY_POSTS_PAGE_BORDER_WIDTH,
  SECTION_MY_POSTS,
  LAYOUT_PG_SIDE_BY_SIDE,
  getPostLayoutParamByName,
  getPostLayoutParamByType,
} from '@wix/communities-blog-client-common';

const stylesParams = {
  pageTitleFont: createStylesParam<StyleParamType.Font>(MY_POSTS_PAGE_TITLE_FONT, {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Page-title', { size: 25, htmlTag: 'h1' }),
  }),
  pageTitleColor: createStylesParam<StyleParamType.Color>(MY_POSTS_PAGE_TITLE_COLOR, {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  }),
  pageTabFont: createStylesParam<StyleParamType.Font>(MY_POSTS_PAGE_TAB_FONT, {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', { size: 16, htmlTag: 'div' }),
  }),
  pageTabColor: createStylesParam<StyleParamType.Color>(MY_POSTS_PAGE_TAB_COLOR, {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  }),
  pageLinkFont: createStylesParam<StyleParamType.Font>(MY_POSTS_PAGE_LINK_FONT, {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', { size: 16, htmlTag: 'a' }),
  }),
  pageLinkColor: createStylesParam<StyleParamType.Color>(MY_POSTS_PAGE_LINK_COLOR, {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
  }),
  pageActiveTabColor: createStylesParam<StyleParamType.Color>(MY_POSTS_PAGE_ACTIVE_TAB_COLOR, {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
  }),
  pageBackgroundColor: createStylesParam<StyleParamType.Color>(MY_POSTS_PAGE_BACKGROUND_COLOR, {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
  }),
  pageBorderColor: createStylesParam<StyleParamType.Color>(MY_POSTS_PAGE_BORDER_COLOR, {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-2', 0.75),
  }),
  pageBorderWidth: createStylesParam<StyleParamType.Number>(MY_POSTS_PAGE_BORDER_WIDTH, {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  }),
  postTitleFont: createStylesParam<StyleParamType.Font>(
    getPostLayoutParamByType(LAYOUT_PG_SIDE_BY_SIDE, SECTION_MY_POSTS, 'titleFont'),
    {
      type: StyleParamType.Font,
      getDefaultValue: wixFontParam('Page-title', { size: 22, htmlTag: 'h2' }),
    },
  ),
  postTitleColor: createStylesParam<StyleParamType.Color>(
    getPostLayoutParamByName(SECTION_MY_POSTS, 'titleColor'),
    {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-5'),
    },
  ),
  postDescriptionFont: createStylesParam<StyleParamType.Font>(
    getPostLayoutParamByType(LAYOUT_PG_SIDE_BY_SIDE, SECTION_MY_POSTS, 'descriptionFont'),
    {
      type: StyleParamType.Font,
      getDefaultValue: wixFontParam('Body-M', { size: 16, htmlTag: 'div' }),
    },
  ),
  postDescriptionColor: createStylesParam<StyleParamType.Color>(
    getPostLayoutParamByName(SECTION_MY_POSTS, 'descriptionColor'),
    {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-5'),
    },
  ),
  postLinkHashtagColor: createStylesParam<StyleParamType.Color>(
    getPostLayoutParamByName(SECTION_MY_POSTS, 'linkHashtagColor'),
    {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-8'),
    },
  ),
  postBackgroundColor: createStylesParam<StyleParamType.Color>(
    getPostLayoutParamByName(SECTION_MY_POSTS, 'backgroundColor'),
    {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-1'),
    },
  ),
  postBorderColor: createStylesParam<StyleParamType.Color>(
    getPostLayoutParamByName(SECTION_MY_POSTS, 'borderColor'),
    {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-2', 0.75),
    },
  ),
  postBorderWidth: createStylesParam<StyleParamType.Number>(
    getPostLayoutParamByName(SECTION_MY_POSTS, 'borderWidth'),
    {
      type: StyleParamType.Number,
      getDefaultValue: () => 1,
    },
  ),
};

export default stylesParams;
